import { useMatch } from 'react-router-dom'
import { useControlStore } from '@editorStores'

/**
 * Whether IFC-import selection mode is active: true only while the IFC Importer page is open and its
 * `selectionMode` targets the IFC/GLB model (rather than the planar model). Replaces the former
 * `controlStore.ifcDrawer` flag.
 *
 * The route guard is required: `selectionMode` defaults to (and resets to) `'ifc-selection'`
 * globally, so without it the derived value would read `true` on every other editor page and
 * wrongly suppress their interactions.
 */
const useIfcImportSelectionActive = (): boolean => {
  const isIfcImport = !!useMatch({ path: '/editor/:projectId/ifc-import', end: false })
  const selectionMode = useControlStore(state => state.selectionMode)
  return isIfcImport && selectionMode === 'ifc-selection'
}

export default useIfcImportSelectionActive
